import { useEffect, useState } from 'react'
import Layout from '../components/Layout'

export default function SkillMd() {
  const [content, setContent] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    loadSkillMd()
  }, [])

  async function loadSkillMd() {
    setLoading(true)
    try {
      // Try to fetch SKILL.md from a known location
      // This would typically be served by your backend or static hosting
      const response = await fetch('/api/v1/skill.md')
      if (!response.ok) {
        throw new Error('SKILL.md not found')
      }
      const text = await response.text()
      setContent(text)
    } catch (err) {
      setError('API documentation is currently unavailable.')
      // Fallback content
      setContent(`# Daily Instagram Story API

## Overview
This API allows you to generate AI-powered Instagram story content.

## Authentication
Use your API key in the Authorization header:
\`\`\`
Authorization: Bearer YOUR_API_KEY
\`\`\`

## Endpoints

### Create Job
\`POST /api/v1/jobs\`

Creates a new content generation job.

### List Jobs
\`GET /api/v1/jobs\`

Lists all your jobs.

### Get Job Results
\`GET /api/v1/jobs/:jobId/results\`

Gets results for a specific job.

## Rate Limits
Please contact support for rate limit information.

## Support
For API support, contact the OfficeX team.
`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">API Documentation</h1>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            {error && (
              <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-sm">
                {error}
              </div>
            )}
            <div className="prose prose-sm max-w-none">
              <pre className="whitespace-pre-wrap bg-gray-50 p-4 rounded-lg text-sm overflow-auto">
                {content}
              </pre>
            </div>
          </div>
        )}
      </div>
    </Layout>
  )
}
